var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSortMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15418_24990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.62252V14.1662C7.5 14.6265 7.1269 14.9996 6.66667 14.9996C6.20643 14.9996 5.83333 14.6265 5.83333 14.1662L5.83333 5.62252L3.92259 7.53327C3.59715 7.8587 3.06951 7.8587 2.74408 7.53327C2.41864 7.20783 2.41864 6.68019 2.74408 6.35475L6.07741 3.02142C6.40285 2.69598 6.93049 2.69598 7.25592 3.02142L10.5893 6.35475C10.9147 6.68019 10.9147 7.20783 10.5893 7.53327C10.2638 7.8587 9.73618 7.8587 9.41074 7.53327L7.5 5.62252Z",
    fill: "#121922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 5.8329C14.1667 5.37266 13.7936 4.99957 13.3333 4.99957C12.8731 4.99957 12.5 5.37266 12.5 5.8329V14.3766L10.5893 12.4659C10.2638 12.1404 9.73618 12.1404 9.41075 12.4659C9.08531 12.7913 9.08531 13.3189 9.41075 13.6444L12.7441 16.9777C13.0695 17.3031 13.5972 17.3031 13.9226 16.9777L17.2559 13.6444C17.5814 13.3189 17.5814 12.7913 17.2559 12.4659C16.9305 12.1404 16.4028 12.1404 16.0774 12.4659L14.1667 14.3766V5.8329Z",
    fill: "#121922"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15418_24990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortMobile);
export default __webpack_public_path__ + "static/media/iconSortMobile.da78481626cba7b22de10f3599fb216b.svg";
export { ForwardRef as ReactComponent };